import api from '../../api/searchAccommodations'
import { router } from '../../main';

const state = {
  searchAccommodations: {},
  searchAccommodationsLocation: null,
  searchAccommodationDayIndex: null,
};

const getters = {
  searchAccommodations: state => state.searchAccommodations,
  searchAccommodationsLocation: state => state.searchAccommodationsLocation,
  searchAccommodationDayIndex: state => state.searchAccommodationDayIndex,
};

const actions = {
  async goToSerchAccommodations({ rootState, commit, dispatch }, { location, isRideManager = false, dayIndex = null }) {
    const lat = location.latitude; // add this values -----------------------
    const lng = location.longtitude;
    commit('setSearchAccommodationLocation', {"lat":lat, "lng":lng});
    commit('setSearchAccommodationDayIndex', dayIndex);
    const { apptoken } = rootState.appauth;
    const response = await api.fetchSearchAccommodationsByLocation(apptoken, lat, lng, isRideManager);
    commit('setSearchAccommodations', response.data);
    dispatch('updateMarkerByScrollerLocationAtAccommodationSearch');
    if (router.currentRoute.path !== '/search_accommodations') {
      router.push('/search_accommodations');
    }
  },
  goToSerchAccommodationsByName({ dispatch }, placeName) {
    dispatch('getPlaceLocationFromNameAndRunCalback', { 
      callback: "goToSerchAccommodationsWithLocation", 
      name: placeName
    });
  },
  goToSerchAccommodationsWithLocation({ dispatch }, location) {
    // Wrapper function to convert location object to new format
    dispatch('goToSerchAccommodations', {
      location: location,
      isRideManager: false,
      dayIndex: null
    });
  },
  
  
};

const mutations = {
  setSearchAccommodations: (state, searchAccommodations) => {
    state.searchAccommodations = searchAccommodations;
  },
  setSearchAccommodationLocation: (state, location) => {
    state.searchAccommodationsLocation = location;
  },
  setSearchAccommodationDayIndex: (state, dayIndex) => {
    state.searchAccommodationDayIndex = dayIndex;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
